<template>
  <div class="">
    <error-msg-component
      v-if="error"
      :messages="messages"
      :error="error"
      :champs-vide="[]"
      :messages-champs-vide="[]"
      @close="error = $event"
      class="mgt-20px"
      title="general.problemOccurred"
      withEmplyFields/>
    <section class="has-text-centered">
      <h1 class="title has-text-default">
        {{ $t('editionCommande.logistiqueImpression.iNeedToPrintPosters') }}
      </h1>
      <qd-button
        class="button is-primary button-modal"
        @click="generationBesoin">
        {{ $t('general.button.generate') }}
    </qd-button>
    </section>
  </div>
</template>

<script>
import { generationBesoinAsync } from '@/api/besoin';
import messageErreur from '@/services/general/messageErreur';
import { TYPE_IMPRESSION } from '@/configuration/bodac/besoin/besoinConfig';
import validation from '@/services/bodac/besoin/validation';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  name: 'GenererBesoins',
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  components: {
    ErrorMsgComponent,
  },
  data() {
    return {
      messages: [],
      error: false,
    };
  },
  methods: {
    async generationBesoin() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generationBesoinAsync({
          commandeId: this.commande.id,
          typeBesoin: TYPE_IMPRESSION,
        });
        this.$emit('refresh');
      } catch (e) {
        if (e.response?.data?.error) {
          validation(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
};

</script>
